import { Component, Input, NgModuleRef, OnInit } from '@angular/core';
import { GroupClassDetailsModel } from '@bayclubs/group-classes-employee-api';
import { ModalService } from '@bayclubs/utils';
import { RealAttendanceSaveComponent } from '../real-attendance-save/real-attendance-save.component';

@Component({
    selector: 'app-group-classes-attendance',
    templateUrl: './group-classes-attendance.component.html',
    styleUrls: ['./group-classes-attendance.component.scss'],
    standalone: false
})
export class GroupClassesAttendanceComponent implements OnInit {
    @Input()
    public model: GroupClassDetailsModel;
    constructor(private modalService: ModalService, private moduleRef: NgModuleRef<any>) {}

    ngOnInit() {}

    registerAttendees() {
        const params = {
            model: this.model
        };
        this.modalService
            .create<RealAttendanceSaveComponent>(RealAttendanceSaveComponent, params, this.moduleRef)
            .subscribe(value => {});
    }

    editAttendees() {
        const params = {
            model: this.model
        };
        this.modalService
            .create<RealAttendanceSaveComponent>(RealAttendanceSaveComponent, params, this.moduleRef)
            .subscribe(value => {});
    }

    public get isRealAttendanceValueIsPlural(): boolean {
        return this.model.realAttendance > 1;
    }

    public get isRealAttendanceEntered(): boolean {
        return this.model.realAttendance !== null;
    }
}
